import { UrlQueryParamsType } from '../types/StorePageType'
import { getQueryParamsAsObject } from './get-query-params-as-object'

const createQueryParameterFromObject = (obj: any): string => {
  let queryParams = ''
  for (const key in obj) {
    if (queryParams !== '') {
      queryParams += '&'
    }
    queryParams += key + '=' + encodeURIComponent(obj[key])
  }
  return queryParams
}

export const getOutClickUrl = (
  offerId: string,
  offerType: string,
  currentUrl: string,
  affiliateLink: string // temporary property for affiliate link frontend fix story: DTSHOPATMS-1503
): string => {
  let storePageUrl = currentUrl
  if (offerId && offerType) {
    // first we need to extract the current params that the url have
    const previousParams = getQueryParamsAsObject(currentUrl)

    const urlObject = new URL(currentUrl)
    storePageUrl = `${urlObject.origin}${urlObject.pathname}`
    const addedParams: UrlQueryParamsType = {
      isModalOpen: 'true',
      offerId,
      offerType
    }
    // we overwrite the previous query params with the new ones
    const paramsToSend = {
      ...previousParams,
      ...addedParams,
      affiliateLink // temporary property for affiliate link frontend fix story: DTSHOPATMS-1503
    }
    storePageUrl = `${storePageUrl}?${createQueryParameterFromObject(
      paramsToSend
    )}`
  }
  return storePageUrl
}
